import React from "react";
import { motion } from "framer-motion";
import SectionTitle from "./SectionTitle";
import { about } from "../content/home";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] } }),
};

const About = () => {
  return (
    <section id="hakkimda" className="relative scroll-mt-24 py-24">
      <div className="mx-auto max-w-7xl container-px">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }} className="section-eyebrow mb-4">
          <span className="h-px w-8 bg-brand-500" /> {about.eyebrow}
        </motion.div>

        <div className="grid gap-12 lg:grid-cols-12">
          <motion.div variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }} className="lg:col-span-7">
            <SectionTitle lead={about.title.lead} accent={about.title.accent} tail={about.title.tail} />
            <div className="mt-6 space-y-4 text-base leading-relaxed text-gray-600 dark:text-white/65">
              {about.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </motion.div>

          <motion.div variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }} className="lg:col-span-5">
            <div className="glass-card gradient-border p-8">
              <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl">
                {about.stats.map((s) => (
                  <div key={s.label} className="bg-white/40 p-6 dark:bg-white/[0.02]">
                    <div className="font-display text-3xl font-bold text-gray-900 dark:text-white">
                      {s.value}
                    </div>
                    <div className="mt-1 text-xs uppercase tracking-wider text-gray-500 dark:text-white/50">
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-6 flex items-center gap-3 text-sm text-gray-600 dark:text-white/55">
                <span className="h-2 w-2 rounded-full bg-gradient-to-r from-brand to-flame" />
                {about.location}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;